export const PXnews = (function() {
	'use strict';

	function init() {
		
		var $filter = $('.filter-toggle');
		var $article = $('.article-preview');
		
		$filter.on("click", function(){


			$(this).addClass('active');
			$(this).siblings().removeClass('active');

			var buttonType = $(this).attr('data-type');
			
			$article.removeClass('hide-me');

			$article.each(function(){
				var articleType = $(this).data("type").split(',');
				var find_type   = articleType.indexOf( buttonType );

				console.log(buttonType);
				console.log(articleType);

				console.log("Find Type: " + find_type);
				console.log("----");

				// -1 means NOT found
				
				if( find_type == -1 ) { 
					$(this).addClass("hide-me");
				}

				});
			});		

		
	}


	return {
		init: init
	};
})();
